import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
    template: `{{value}}`,
})
export class CustomUpdatableCellComponent implements OnInit, OnDestroy {

    constructor(private changeDetectorRef: ChangeDetectorRef) { }

    @Input() rowData: any;
    @Input() value: any;

    change: Observable<any>;
    customInput: string;

    ngOnInit(): void {
        if (this.change) {
            this.change.subscribe(
                value => {
                    this.value = this.rowData[this.customInput];
                    if (!this.changeDetectorRef['destroyed']) {
                        this.changeDetectorRef.detectChanges();
                    }
                }
            );
        }
    }

    ngOnDestroy(): void {
        this.changeDetectorRef.detach();
    }
}
